<template>
  <div id="app">
    <HelloWorld v-if="isLogin" />
    <Login v-else @getToken="isLogin = true" />
  </div>
</template>

<script>
import HelloWorld from "./page/index.vue";
import Login from "./page/login.vue";

export default {
  name: "App",
  components: {
    HelloWorld,
    Login
  },
  data() {
    return {
      isLogin: localStorage.getItem("token") || ''
    };
  },
  created() {

  },

  mounted() {

  },
  methods: {

  },


};
</script>

<style>
#app {
  font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
  background: #f8f8f8;
}

html {
  font-size: 14px;
}

body {
  margin: 0;
  padding: 0;
  font-size: 1rem;
}

@font-face {
  font-family: 'DongFangDaKai';
  src: url('./assets/fonts/AlimamaDongFangDaKai-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
  /* 优化加载时的字体显示 */
}
</style>
